import * as React from 'react';
import { UserHistoryItem } from '../../../../types/UserHistory';
import UserHistoryItemComponent from './UserHistoryItem/UserHistoryItem';
import './UserHistory.css';
import Button from '../../../Button/Button';

interface Props {
	items: UserHistoryItem[];
	page?: number;
	onMoreLoad?: (lastId: number) => void;
}

const UserHistoryComponent: React.FC<Props> = ({ items, page, onMoreLoad }) => {
	const more = () => {
		onMoreLoad(items[items.length - 1].id);
	};

	return (
		<div className="userHistory">
			<div>
				{items
					.filter((item) => item.book)
					.map((item) => {
						return <UserHistoryItemComponent item={item} key={item.id} />;
					})}
				
				<Button onClick={more}>
					Загрузить еще
				</Button>
			</div>
		</div>
	);
};

export default UserHistoryComponent;
